import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const sendGaClickEvent = () => {
    window.dataLayer.push({
        event: 'click',
        'event_category': 'Header Scoreboard Click',
        'event_label': 'previous'
    });
};

const PrevArrow = () => (
    <div className="indicator" onClick={sendGaClickEvent}>
        <FontAwesomeIcon icon={['fas', 'chevron-left']}/>
    </div>
);

export default PrevArrow;
